
function equalHeight() {
    $.fn.extend({
        equalHeights: function() {
            var top = 0;
            var row = [];
            var classname = ('equalHeights' + Math.random()).replace('.', '');
            $(this).each(function() {
                var thistop = $(this).offset().top;
                if (thistop > top) {
                    $('.' + classname).removeClass(classname);
                    top = thistop;
                }
                $(this).addClass(classname);
                $(this).height('auto');
                var h = (Math.max.apply(null, $('.' + classname).map(function() {
                    return $(this).outerHeight();
                }).get()));
                $('.' + classname).height(h);
            }).removeClass(classname);
        }
    });
    $('.classname').equalHeights();
    $('.product-card__image-with-placeholder-wrapper').equalHeights();
   $('.product-card__detail p').equalHeights();
   // $('.search-container .list-view-item__image-wrapper').equalHeights();
   // $('.search-container .product-card__title').equalHeights();

   $('.search-container .list-view-item__image-wrapper').equalHeights();
   setTimeout(function(){ 
       $('.product-like-slider .swiper-slide a i').equalHeights();
       $('.product-like-slider .product-slider-content  p').equalHeights();
       $('.product-dress-slider .product-slider-content  p').equalHeights();
        $('.product-dress-slider .swiper-slide a i').equalHeights();
    }, 2000);

   // $('.product-dress-slider .swiper-slide a i').equalHeights();
   // $('.product-like-slider .swiper-slide a i').equalHeights();
   // $('.product-dress-slider .product-slider-content  p').equalHeights();
   //  $('.product-like-slider .product-slider-content  p').equalHeights();
   setTimeout(function(){ 
       $('.search-container .list-view-item__image-wrapper').equalHeights();
        $('.search-container .product-card__title').equalHeights();
    }, 2000);
}


//Hide and Show Add New Adddress
    function addNewAddress() {
        document.getElementById('OrderList').style.display = 'none';
        document.getElementById('AddressNewButton').style.display = 'none';
        document.getElementById('AddressNewForm').style.display = 'block';
    }
    function cancelAddNewAddress() {
        document.getElementById('OrderList').style.display = 'block';
        document.getElementById('AddressNewButton').style.display = 'block';
        document.getElementById('AddressNewForm').style.display = 'none';
    }   

//Customer form ajax call
function saveCustomerInformation() {                 
       $('.action-button').trigger('click');
}
//Change password button
function changePassword() {  
	document.location.href = '/account/login#recover';
}
$(document).ready(function() {
  equalHeight();

  // stcikey header js
  $(window).scroll(function(e){
     if($(window).scrollTop() > 50){
        $("#shopify-section-header").addClass('small-header');
        $("body").addClass('header-stick');
     }
     else{
       $("#shopify-section-header").removeClass('small-header');
      $("body").removeClass('header-stick');
     }    
   });

  // Category page with no-banner js
  if($(".category-text-wrapper").children().hasClass("category-left-img")){
    $(".category-text-wrapper").removeClass("category-no-banner");
  }else{
    
    $(".category-text-wrapper").addClass("category-no-banner");
  }
  
    // article slider
    var swiper = new Swiper('.article-slider.swiper-container', {
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    // Spotlight slider
    var swiper = new Swiper('.spotlight-slider', {
        scrollbar: {
            el: '.swiper-scrollbar',
            hide: true,
        },
        slidesPerView: 4,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            767: {
                slidesPerView: 1,
            },
            991: {
                slidesPerView: 3,
            },
        }
    });
    // Saloni's World slider
    var mySwiper = new Swiper('.world-slider', {
        slidesPerView : 2.632,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            767: {
                slidesPerView : 1.2,
            },
            1023: {
                slidesPerView : 1.75,
            },
            1279: {
                slidesPerView : 2.389,
            },

        }
    });

    // Trending slider
    var mySwiper = new Swiper('.trending-slider', {
        slidesPerView: 3.5,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            767: {
                slidesPerView : 1.06,
            },
            1023: {
                slidesPerView : 1.83,
            },
            1279: {
                slidesPerView : 2.48,
            },
            1439: {
                slidesPerView : 3.1,
            },
        }
    });
    
    // Location-popup JS
    $('.custom-modal-open').click(function(e) {
        e.stopPropagation();
        $('.custom-modal').addClass('visible');
        $('html, body').addClass('modal-overlay');
    }); 

    $('.location-popup .close a').click(function() {
        $('.custom-modal').removeClass('visible');
        $('html, body').removeClass('modal-overlay');
    });
    $(".location-popup").click(function(e){
      e.preventDefault();
      e.stopPropagation();
    });
  
    // Subscribe-popup JS
    $('.subscribe-modal-link').click(function(e) {
        e.stopPropagation();
        $('.subscribe-modal').addClass('visible');
        $('html, body').addClass('modal-overlay');
    }); 
    $('.subscribe-popup-right .close a').click(function() {
        $('.subscribe-modal').removeClass('visible');
        $('html, body').removeClass('modal-overlay');
    });
    $(".subscribe-popup-wrapper").click(function(e){
      e.preventDefault();
      e.stopPropagation();
    });

      // sizeguide-popup js
     $('.sizeguide-modal-link').click(function(e){
        e.stopPropagation();
        $('.sizeguide-modal').addClass('visible');
        $('body').addClass('modal-overlay');
    }); 

     $('.sizeguide-modal .close').click(function(){
        $('.sizeguide-modal').removeClass('visible');
        $('body').removeClass('modal-overlay');
    });
    $(".sizeguide-modal-wrapper").click(function(e){
      e.preventDefault();
      e.stopPropagation();
    });
  

     $(document).click(function(event) {
        if (!$(event.target).closest(".location-popup,.custom-modal-open").length) {
            $("body").find(".custom-modal").removeClass("visible");
            $('html, body').removeClass('modal-overlay');
        }
        if (!$(event.target).closest(".subscribe-popup-wrapper,.subscribe-modal-link").length) {
            $("body").find(".subscribe-modal").removeClass("visible");
            $('html, body').removeClass('modal-overlay');
        }
        if (!$(event.target).closest(".sizeguide-modal-wrapper,.sizeguide-modal-link").length) {
            $("body").find(".sizeguide-modal").removeClass("visible");
            $('html, body').removeClass('modal-overlay');            
        }
        $(".sort-by-popup").removeClass("filter-popup");
        $("body").removeClass("filter-popup");    
        
    });
  
    //  Category Page Filter Popup js
    $(".filter-sortby-wrapper .filter-link").click(function(){
          $(".category-left").addClass("filter-popup");
          $("body").addClass("filter-popup");
    });
    $(".filter-title .close").click(function(){
        $(".category-left").removeClass("filter-popup");
        $("body").removeClass("filter-popup");
    });

    //  Category Page Sort By Popup js
    $(".filter-sortby-wrapper .sort-by-link").click(function(e){
        e.stopPropagation();
        $(".sort-by-popup").addClass("filter-popup");
        $("body").addClass("filter-popup");
    });
    $(".sort-by-wrapper").click(function(e){
      e.stopPropagation();
    });

    $(".sort-by-title .close").click(function(e){
       e.stopPropagation();
        $(".sort-by-popup").removeClass("filter-popup");
        $("body").removeClass("filter-popup");
    });
  
      // size-guide accordian js
    $('.sizeguide-accordian .accordian-box:first-child .accordian-content').slideDown();
    $('.sizeguide-accordian .accordian-box:first-child').addClass('open');

    $(".sizeguide-accordian .accordian-title").click(function () {      
        $(this).closest(".accordian-box").siblings().removeClass('open');
        $(this).closest(".accordian-box").siblings().find(".accordian-content").stop(true, true).slideUp(); 
        $(this).closest(".accordian-box").toggleClass('open').find(".accordian-content").stop(true, true).slideToggle();
    });
    // Mobile menu open JS
      $(".toggle-link").click(function(e){
        e.stopPropagation();
        $("body").addClass("menu-open");
        $(".mobile-nav-wrapper").addClass("js-menu--is-open");
        if($('body').hasClass('search-open')){   
            $('body').removeClass('search-open');
        }    
      });
      $('body').click(function(e){
        if($('body').hasClass('menu-open')){
            $(".mobile-nav-wrapper").removeClass("js-menu--is-open");
            $('body').removeClass('menu-open'); 
        }
    });
      $(".mobile-nav-wrapper").click(function(e){
        e.stopPropagation();
      });


    // footer Image slider
    var swiper = new Swiper('.footer-img-slider', {
        slidesPerView : 3,
        spaceBetween: 29,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            767: {
                slidesPerView : 1,
                spaceBetween: 0,
            },
            1023: {
                slidesPerView : 2,
                spaceBetween: 29,
            },
        }
    });
    // shoppingbag-feature-slider
    var swiper = new Swiper('.shoppingbag-feature-slider', {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            767: {
                slidesPerView : 1,
                spaceBetween: 0,
            },
            1023: {
                slidesPerView : 2,
                spaceBetween: 30,
            },
        }
    });
    // shoppingbag-img-slider
    // var swiper = new Swiper('.shoppingbag-product-slider', {
    //     slidesPerView: 4,
    //     spaceBetween: 30,
    //     pagination: {
    //         el: '.swiper-pagination',
    //         clickable: true,
    //     },
    //     breakpoints: {
    //         767: {
    //             slidesPerView : 2,
    //             spaceBetween: 20,
    //         },
    //         1023: {
    //             slidesPerView : 3,
    //             spaceBetween: 30,
    //         },
    //         1279: {
    //             slidesPerView : 3,
    //             spaceBetween: 30,
    //         },
    //     }
    // });
  // Product Page jacquart-print-block Swiper js
    var mySwiper = new Swiper('.jacquart-print-slider', {
        slidesPerView: 2,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            767: {
                slidesPerView : 1.23,
            },
        }
    });
     // Product Page product-slider Swiper js
     setTimeout(function(){ 
         var mySwiper = new Swiper('.product-like-slider', {
            slidesPerView: 4,
            spaceBetween: 60,
            // observer: true,
            // observeParents: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                767: {
                  slidesPerView: 2,
                  spaceBetween: 19,
              },
               1279: {
                  spaceBetween: 29,
              },
          }
      });
      }, 800);

  //   var mySwiper = new Swiper('.product-like-slider', {
  //       slidesPerView: 4,
  //       spaceBetween: 60,
  //       // observer: true,
  //       // observeParents: true,
  //       pagination: {
  //           el: '.swiper-pagination',
  //           type: 'bullets',
  //           clickable: true,
  //       },
  //       breakpoints: {
  //           767: {
  //             slidesPerView: 2,
  //             spaceBetween: 19,
  //         },
  //          1279: {
  //             spaceBetween: 29,
  //         },
  //     }
  // });
  //   // Product Page dress-product-slider Swiper js
    var mySwiper = new Swiper('.product-dress-slider', {
        slidesPerView: 4,
        spaceBetween: 60,
        observer: true,
        observeParents: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            767: {
              slidesPerView: 2,
              spaceBetween: 19,
          },
           1279: {
              spaceBetween: 29,
          },
      }
  });
    // footer-contact slider
    var swiper = new Swiper('.footer-contact-swiper', {
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

     // account-landing js
     if ($(window).width() <= 768) {
       $('.landing-account .landing-account-main .down-arrow').click(function (e) {
         $(this).closest(".account-block").siblings().removeClass('active');
          $(this).closest(".account-block").siblings().find("p").stop(true, true).slideUp('400');
          $(this).closest(".account-block").toggleClass('active').find("p").stop(true, true).slideToggle('400');

       });
     }

    //footer Accordion
    if ($(window).width() <= 1023){
        $(".accordion-link").click(function () {
            $(this).closest(".site-footer__item").siblings().find('.open').removeClass('open');
            $(this).closest(".site-footer__item").siblings().find(".site-footer__linklist").stop(true, true).slideUp('slow');
            $(this).toggleClass('open').closest(".site-footer__item").find(".site-footer__linklist").stop(true, true).slideToggle('slow');
        });
    }

    // cms page js
    if ($(window).width() < 1025) {
        $('.customer-menubar').click(function(){
            $('.cms-page .cms-main .sidebar ul').slideToggle();
            $(this).toggleClass('flip-icon');
        });
        $('.cms-page .cms-main .sidebar ul li a').click(function(){
            $('.cms-page .cms-main .sidebar ul').slideUp();
            $('.customer-menubar').removeClass('flip-icon');
            var title_vals = $(this).text();                    
            $('.customer-menubar span').text(title_vals);
        });        
      
    }

    // faq  Accordian Js    
    $(".faq-ac-header").click(function () {
        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
            $(this).next().slideUp();
        } else {
            $(this).parent().siblings('.faq-accordian-content').removeClass('active');
            $(this).parent().siblings('.faq-accordian-content').children('.faq-ac-body').slideUp();
            $(this).next().find(".faq-accordian-content").removeClass("active");
            $(this).next().find(".faq-accordian-content").children(".faq-ac-body").slideUp('fast');
            $(this).parent().addClass('active');
            $(this).next().slideDown();
        }
    });

    // cutom scroll js for mini-shopping bag
     $(".cart-items-listing").mCustomScrollbar('destroy');  
      $(document).on('click','.js-ajax-add-to-cart',function(){
    
        if($('.cart-items-listing').hasClass('mCustomScrollbar')){
          $(".cart-items-listing").mCustomScrollbar('destroy');
        }
        setTimeout(function(){
          $('.cart-items-listing').mCustomScrollbar();
        }, 1000); 
      });
  
  
  /*custom tab*/
  $('.cms-tab-container .tab_content').hide();
   $("ul.tabs li").click(function() {
        $("ul.tabs li").not(this).removeClass("active");
        $(this).toggleClass("active");
        var $this= $(this).attr("rel");
        $('.cms-tab-container .tab_content').each(function(){
        if($this == $(this).attr('id')){
            $(this).fadeToggle();
        }
          else{
            $(this).hide(); 
        }
     });
    });
  // sizeguide-tab js
    $('.sizeguide-modal-wrapper .tabbing-wrpper ul.tabs li').click(function(e){
        e.preventDefault();
        var tab_id = $(this).attr('data-tab');
        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
    })

    // sizeguide-tab js
    $('.product-tabbing-block .tabbing-wrpper ul.tabs li').click(function(e){
        e.preventDefault();
        var tab_id = $(this).attr('data-tab');
        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#"+tab_id).addClass('current');     

         setTimeout(function(){ 
           $('.product-dress-slider .product-slider-content  p').equalHeights();
            $('.product-dress-slider .swiper-slide a i').equalHeights();
        }, 1000);      
    });

  
  // general-tab js
    $('.tabbing-wrpper ul.tabs li').click(function(e){
        e.preventDefault();
        var tab_id = $(this).attr('data-tab');
        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
    })
  
    //  Product-detail accordian js
    $(".product-detail-accordian .accordian-title").click(function () {      
        $(this).closest(".accordian-box").siblings().removeClass('open');
        $(this).closest(".accordian-box").siblings().find(".accordian-content").stop(true, true).slideUp(); 
        $(this).closest(".accordian-box").toggleClass('open').find(".accordian-content").stop(true, true).slideToggle();
    });
    // category size accordian js
    if($(window).width() > 1023){
       $(".category-accordion .accordian-title").click(function () {      
          $(this).closest(".accordian-box").siblings().removeClass('open');
          $(this).closest(".accordian-box").siblings().find(".accordian-content").stop(true, true).slideUp(); 
          $(this).closest(".accordian-box").toggleClass('open').find(".accordian-content").stop(true, true).slideToggle();
      });
    }
    //   product slider js
    if ($(window).width() >= 992){
      var galleryThumbs = new Swiper('.product-slider-wrapper  .gallery-thumbs', {
        slidesPerView: 5,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        direction: 'vertical',
      });
      var galleryTop = new Swiper('.product-slider-wrapper  .gallery-top', {
         effect: 'fade',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: galleryThumbs
        },
        pagination: {
              el: '.swiper-pagination',
              clickable: true,
          },
      });
      //desktop zoom img js     
      $(".gallery-top .swiper-slide .product-img").zoomToo({
        magnify: 2
      });
    }
    else{
        var galleryTop = new Swiper('.product-slider-wrapper  .gallery-top', {  
        slidesPerView: 1,     
        pagination: {
              el: '.swiper-pagination',
              clickable: true,
          },
      });
    } 
// galleryTop.controller.control = galleryThumbs;
// galleryThumbs.controller.control = galleryTop;
    // product zooom js for mobile
      $('.product-slider-wrapper .zoomplus-link').click(function(e){
        e.preventDefault();
        var image_src = $('.product-slider-wrapper .gallery-top').find('.swiper-slide-active img').attr('src');
        $('body').addClass('zoom-img-open');
        $('.zoom-wrappper').addClass('open').find('.active-img').attr("src", image_src);
      });
     $('.zoom-wrappper .zoomminus-link').click(function(e){
        e.preventDefault();
        $('body').removeClass('zoom-img-open');
        $('.zoom-wrappper').removeClass('open');
     });
  
    // product detil color radio js  
    $('.color-list label').click(function(){      
        $(this).addClass('active');
         var title_vals = $(this).text();                   
        $('.color-title span').text(title_vals);
        $(this).closest('.color-box').siblings().find('label').removeClass();
    });
    if ($('.color-list label').hasClass('active')){           
        var title_vals = $('.color-list label.active').text();                   
        $('.color-title span').text(title_vals);
    }
  
 
    // Custom SortBy Select
      $(".sort-by-select").dropkick({
        mobile: true
      });
  
  
  //   custom scroll for dropdown category page
  $('.custom-select-wrapper .dk-select-options').mCustomScrollbar();
  
  //   custom scroll for dropdown category page
  $('.sizeguide-modal-wrapper').mCustomScrollbar();

  // size guide  table hover js
  $('.size-table td:not(:first-child)').hover(function() {
      $(this).closest('tr').find('td,th').addClass('highlight');
      $(this).closest('table').find('tr :nth-child('+($(this).index()+1)+')').addClass('highlight');
      $(this).addClass('current-highlight');
  }, function() {
      $(this).closest('tr').find('td,th').removeClass('highlight');
      $(this).closest('table').find('tr :nth-child('+($(this).index()+1)+')').removeClass('highlight');
      $(this).removeClass('current-highlight');
  });

  $('.size-guide-table td:not(:first-child,:nth-child(2))').hover(function() {
      $(this).closest('tr').find('td').addClass('highlight');
      $(this).closest('table').find('tr :nth-child('+($(this).index()+1)+')').addClass('highlight');
      $(this).addClass('current-highlight');
  }, function() {
      $(this).closest('tr').find('td,th').removeClass('highlight');
      $(this).closest('table').find('tr :nth-child('+($(this).index()+1)+')').removeClass('highlight');
      $(this).removeClass('current-highlight');
  });
  
      //Privacy Policy Back To Top Button 
      $("#backToTop").click(function () {
           $("html, body").animate({scrollTop: 0}, 1000);
    });
      //cart qty increment and decrement
    $(".quantity-dropdown select").change(function(){   
        var amount = $(this).val();  
         $(this).parents(".cart__row").find('.cart__qty-input').attr('value',amount);   
      });
    $(".cart-qty-plus").click(function() {
        var amount = $(this).prev().attr('value');  
        if (amount < 10) {
            amount++;
        }  
        $(this).prev().attr('value', amount);
    });

    $(".cart-qty-minus").click(function() {
      var line=$(this).parents(".cart__row").data('cart-item-index'); 
      var amount = $(this).next().attr('value');    
      
        if (amount > 0) {
              amount--;
        }
      $(this).next().attr('value', amount);  
    });


    $('.search-header__submit').click(function(e){
        e.stopPropagation();
      if($('body').hasClass('search-open')){
         $('body').removeClass('search-open');
      }else{
        $('body').addClass('search-open');
      }
    });
    $('.search-wrapper').click(function(e){
        e.stopPropagation();
    });
    $('body').click(function(e){
      if($('body').hasClass('search-open')){
          $('body').removeClass('search-open');
      }
    });

      
});

$(window).resize(function() {
  
  equalHeight();
  if($(window).width() >= 1025 && $('body').hasClass('menu-open')){
        $(".mobile-nav-wrapper").removeClass("js-menu--is-open");
        $('body').removeClass('menu-open'); 
    }

    // account-landing js
     // if ($(window).width() <= 768) {
     //   $('.landing-account .landing-account-main .down-arrow').click(function (e) {
     //     $(this).closest(".account-block").siblings().removeClass('active');
     //      $(this).closest(".account-block").siblings().find("p").stop(true, true).slideUp('400');
     //      $(this).closest(".account-block").toggleClass('active').find("p").stop(true, true).slideToggle('400');

     //   });
     // }
    
     //footer Accordion
    //  if ($(window).width() <= 1023){
    //     $(".accordion-link").click(function () {
    //         $(this).closest(".site-footer__item").siblings().find('.open').removeClass('open');
    //         $(this).closest(".site-footer__item").siblings().find(".site-footer__linklist").stop(true, true).slideUp('slow');
    //         $(this).toggleClass('open').closest(".site-footer__item").find(".site-footer__linklist").stop(true, true).slideToggle('slow');
    //     });
    // }
    // category size accordian js
    // if($(window).width() > 1023){
    //    $(".category-accordion .accordian-title").click(function () {      
    //       $(this).closest(".accordian-box").siblings().removeClass('open');
    //       $(this).closest(".accordian-box").siblings().find(".accordian-content").stop(true, true).slideUp(); 
    //       $(this).closest(".accordian-box").toggleClass('open').find(".accordian-content").stop(true, true).slideToggle();
    //   });
    // }
  
    //   product slider js
    if ($(window).width() >= 992){
      var galleryThumbs = new Swiper('.product-slider-wrapper  .gallery-thumbs', {
        slidesPerView: 5,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        direction: 'vertical',
      });
      var galleryTop = new Swiper('.product-slider-wrapper  .gallery-top', {
        
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: galleryThumbs
        },
        pagination: {
              el: '.swiper-pagination',
              clickable: true,
          },
      });
       //desktop zoom img js
      $(".gallery-top .swiper-slide .product-img").zoomToo({
        magnify: 2
      });
    }
    else{
        var galleryTop = new Swiper('.product-slider-wrapper  .gallery-top', {  
        slidesPerView: 1,     
        pagination: {
              el: '.swiper-pagination',
              clickable: true,
          },
      });
    } 

});

$(window).on('load', function () {
     // cutom scroll js for mini-shopping bag
//     $(".cart-items-listing").mCustomScrollbar();

//cart product set dropdown value
  $('.quantity-dropdown select').each(function(){ 
//     console.log($(this).parents(".cart__row").find('.cart__qty-input').attr('value'));
    $(this).val($(this).parents(".cart__row").find('.cart__qty-input').attr('value'));
  });
  
  
//   function openPopup() {        
//      $('#subscribePopupOpen').trigger('click');        
//     }
//     var visited = $.cookie('visited');              
//     if (visited == 'yes') {    
//       console.log('openPopup cookie enable');        
//     } else { 
//        openPopup(); 
//     }

//     $.cookie('visited', 'yes', {  
//         expires: 1 
//     });
    
  
  if($("#videoWrapper").length > 0){
    video_init();
  }
  
 function getEmbeddedPlayer(url){
        var output = '';
        var youtubeUrl = url.match(/watch\?v=([a-zA-Z0-9\-_]+)/);
        var youtubeUrl1 = url.match(/youtu.be/);
        var cdnURL = url.match(/cdn.shopify.com/);
        var vimeoUrl = url.match(/^https?:\/\/(www\.)?vimeo\.com\/(clip\:)?(\d+).*$/);
        if( youtubeUrl ){
          output = '<iframe src="https://www.youtube.com/embed/'+youtubeUrl[1]+'?rel=0;&autoplay=1&mute=1&loop=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
//             output = '<iframe width="'+width+'" height="'+height+'" src="https://www.youtube.com/embed/'+youtubeUrl[1]+'?rel=0" frameborder="0" allowfullscreen>';
        }
        else if( youtubeUrl1 ){
            var res = url.split("youtu.be/");
          output = '<iframe src="https://www.youtube.com/embed/'+res[1]+'?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
//             output = '<iframe width="'+width+'" height="'+height+'" src="https://www.youtube.com/embed/'+res[1]+'" frameborder="0" allowfullscreen>';
        }
        else if(vimeoUrl){
            output =  '<iframe src="https://player.vimeo.com/video/'+vimeoUrl[3]+'?autoplay=1" frameborder="0"></iframe>';
        }
       else if(cdnURL){
            output =  '<iframe src="'+url+'" frameborder="0"></iframe>';
        }
       else{
            output = '<p>no video url found - vimeo and youtube supported</p>';
        }
        console.log('dsadas'+output);
        document.getElementById("videoWrapper").innerHTML = output;

        return true;
    }
    function video_init()
    {
    var url = document.getElementById("videoURL").value;
    var output = getEmbeddedPlayer(url);
    return false;
    }
     
});

  //CMs page menu in mobile view
  $('#CSSidebar li').each(function(){
    if ($(this).attr('class') == 'active'){                 
      var title_vals = $(this).text();                      
      $('.customer-menubar span').text(title_vals);
    }
  });

  $('#AccountMenuSideBar li').each(function(){
    if ($(this).attr('class') == 'active'){                 
      var title_vals = $(this).text();                      
      $('.customer-menubar span').text(title_vals);
    }
  });
//hide default input of product page
$(".hideoriginalInput").css("display", "none");

// $('#sizeGuide').append('<div style="display:flex;"><p>Please see our size guide </p> <a href="#" title="Size Guide" class="sizeguide-modal-link" style="margin-left:5px;">here</a></div>');

//Wishlist Count Code
var  variantwish = JSON.parse(localStorage.getItem('user_variantwish'))  ;
if(variantwish) {
	var total = variantwish.length;
	$('#wishlist-count').text(total);
}


//Size Guide
	if($(".size-info").length == 0) {
      	if($(".sizeGuide-schema").length > 0)
  			document.getElementById('sizeGuide-schema').style.display = 'none';
   	 }


